// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__OcBOQ","subheader":"ReorderModal_subheader__2LW8a","listWrap":"ReorderModal_listWrap__3_9Ln"};